import { render, staticRenderFns } from "./EditCustomerUser.vue?vue&type=template&id=f4bcb526"
import script from "./EditCustomerUser.vue?vue&type=script&lang=js"
export * from "./EditCustomerUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports